function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ApiConstants from 'invision-core/src/api/constants';
import { ThunkHelper } from 'invision-core';
export var RETRIEVE_PRODUCTS_CONSTANTS = {
  BEGIN: 'RETRIEVE_PRODUCTS_BEGIN',
  SUCCESS: 'RETRIEVE_PRODUCTS_SUCCESS',
  FAILURE: 'RETRIEVE_PRODUCTS_FAILURE'
};
var RETRIEVE_PRODUCTS_EVENTS = [RETRIEVE_PRODUCTS_CONSTANTS.BEGIN, RETRIEVE_PRODUCTS_CONSTANTS.SUCCESS, RETRIEVE_PRODUCTS_CONSTANTS.FAILURE];
export var retrieveProductsPromise = function retrieveProductsPromise(dispatch, customerId, additionalOpts) {
  var defaultData = {
    SortBy: 2,
    SortDirection: 2
  };
  var requestData = Object.assign(defaultData, additionalOpts);
  if (requestData && requestData.SearchString) {
    //Multiple hyphens will cause the service to throw a 500 error
    requestData.SearchString = requestData.SearchString.replace(/-+/g, '-');
  }
  return ThunkHelper(dispatch, RETRIEVE_PRODUCTS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchLocker',
    data: requestData,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveProducts = function retrieveProducts(customerId) {
  var additionalOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    return retrieveProductsPromise(dispatch, customerId, additionalOpts);
  };
};
export var SET_CURRENT_PAGE = 'SET_PRODUCTS_CURRENT_PAGE';
export var setCurrentPage = function setCurrentPage(page) {
  return {
    type: SET_CURRENT_PAGE,
    payload: page
  };
};
export var SET_INCLUDED_EXPIRED_FILTER = 'SET_PRODUCTS_INCLUDED_EXPIRED_FILTER';
export var setIncludedExpiredFilter = function setIncludedExpiredFilter(includedFilter) {
  return {
    type: SET_INCLUDED_EXPIRED_FILTER,
    payload: includedFilter
  };
};
export var SET_INCLUDED_REMOVED_FILTER = 'SET_PRODUCTS_INCLUDED_REMOVED_FILTER';
export var setIncludedRemovedFilter = function setIncludedRemovedFilter(includedFilter) {
  return {
    type: SET_INCLUDED_REMOVED_FILTER,
    payload: includedFilter
  };
};
export var SET_INCLUDED_SEARCH_FILTER = 'SET_PRODUCTS_INCLUDE_SEARCH_FILTER';
export var setIncludedSearchFilter = function setIncludedSearchFilter(includedSearch) {
  return {
    type: SET_INCLUDED_SEARCH_FILTER,
    payload: includedSearch
  };
};
export var SET_ACTIVE_PRODUCT = 'SET_ACTIVE_PRODUCT';
export var setActiveProduct = function setActiveProduct(product) {
  return {
    type: SET_ACTIVE_PRODUCT,
    payload: product
  };
};
export var SET_PRODUCTS_PAGE_SIZE_PREFERENCE = 'SET_PRODUCTS_PAGE_SIZE_PREFERENCE';
export var setPageSizePreference = function setPageSizePreference(pageSize) {
  return {
    type: SET_PRODUCTS_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};
export var SET_PRODUCTS_CLASSIFICATION = 'SET_PRODUCTS_CLASSIFICATION';
export var setProductsClassificationType = function setProductsClassificationType(selection) {
  return {
    type: SET_PRODUCTS_CLASSIFICATION,
    payload: selection
  };
};
export var EMPTY_PRODUCTS_LIST = 'EMPTY_PRODUCTS_LIST';
export var emptyProductsList = function emptyProductsList() {
  return {
    type: EMPTY_PRODUCTS_LIST
  };
};
export var REMOVE_PRODUCTS_FILTER = 'REMOVE_PRODUCTS_FILTER';
export var removeProductsFilter = function removeProductsFilter() {
  return {
    type: REMOVE_PRODUCTS_FILTER
  };
};
export var REMOVE_PRODUCTS_CONSTANTS = {
  BEGIN: 'REMOVE_PRODUCTS_BEGIN',
  SUCCESS: 'REMOVE_PRODUCTS_SUCCESS',
  FAILURE: 'REMOVE_PRODUCTS_FAILURE'
};
var REMOVE_PRODUCTS_EVENTS = [REMOVE_PRODUCTS_CONSTANTS.BEGIN, REMOVE_PRODUCTS_CONSTANTS.SUCCESS, REMOVE_PRODUCTS_CONSTANTS.FAILURE];
export var removeProductsPromise = function removeProductsPromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, REMOVE_PRODUCTS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SubmitRemoveOrder',
    data: {
      LockerItemIds: data.ItemsToRemove,
      RemoveReasonCode: data.ReasonCode,
      SendNotification: data.SendNotification
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var removeAdHocProductsPromise = function removeAdHocProductsPromise(dispatch, customerId, data, executionDate) {
  return ThunkHelper(dispatch, REMOVE_PRODUCTS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SubmitChangeOfServiceOrder',
    data: {
      ExecutionDate: executionDate || undefined,
      RemoveItems: data.ItemsToRemove,
      ReasonCode: data.ReasonCode,
      SendNotification: data.SendNotification
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var removeProducts = function removeProducts(customerId, data, isAdHocProduct, executionDate) {
  return function (dispatch) {
    return isAdHocProduct ? removeAdHocProductsPromise(dispatch, customerId, data, executionDate) : removeProductsPromise(dispatch, customerId, data);
  };
};
export var SET_PRODUCTS_LIST_SORT_CRITERIA = 'SET_PRODUCTS_LIST_SORT_CRITERIA';
export var setSortCriteria = function setSortCriteria(sortCriteria) {
  return {
    type: SET_PRODUCTS_LIST_SORT_CRITERIA,
    payload: sortCriteria
  };
};
export var SET_REMOVE_PRODUCT_EXECUTION_OPTIONS = 'SET_REMOVE_PRODUCT_EXECUTION_OPTIONS';
export var setRemoveProductExecutionOptions = function setRemoveProductExecutionOptions(executionOptions) {
  return {
    type: SET_REMOVE_PRODUCT_EXECUTION_OPTIONS,
    payload: executionOptions
  };
};